<template>
  <div class="create-collection-page">
    <div class="page-name">
      创建论文集
      <a-tooltip placement="bottomRight" >
        <template #title>
          <span>论文集是具有某个共性的论文的集合，是一种论文管理工具。通过创建论文集，可以高效管理个人所需要的优质论文，为科研助力。</span>
        </template>
        <question-circle-outlined />
      </a-tooltip>
    </div>

    <div class="form">
      <!-- <div class="label-name"><span class="red">*</span>标题（最多50字）</div> -->
      <div class="title-input">
        <a-input
          v-model:value="title"
          placeholder="请输入标题（最多50个字）"
          style="border: none"
          maxlength="50"
        />
        <div class="count">{{ title.length }}/50</div>
      </div>

      <!-- <div class="tags">
        <a-tag
          v-for="(tag, index) in tags"
          color="warning"
          :closable="true"
          :key="tag.topicId"
          @close="handleClose(index)"
        >
          {{ tag.topicName }}
        </a-tag>
        <div class="search" v-if="inputVisible && tags.length < 5">
          <a-input
            ref="inputRef"
            type="text"
            size="small"
            v-model:value="tagName"
            :style="{ width: '105px' }"
            @change="changeTagName"
          />
          <div class="list" v-show="selectList.length > 0">
            <div
              class="item"
              v-for="item in selectList"
              :key="item.topicId"
              @click.stop="selectTag(item)"
            >
              {{ item.topicName }}
            </div>
          </div>
        </div>

        <a-tag
          v-if="!inputVisible && tags.length < 5"
          style="
            background: #fff;
            border: none;
            color: #ea7455;
            cursor: pointer;
          "
          @click.stop="showInput"
        >
          <plus-outlined />
          添加主题词({{ tags.length }}/5)
        </a-tag>

        <div class="desc">
          <a-textarea
            show-count
            :maxlength="200"
            :auto-size="{ minRows: 10, maxRows: 10 }"
            placeholder="请输入论文集简介"
            v-model:value="content"
          ></a-textarea>
        </div>
      </div> -->
 
 <div class="tags">
        <span v-show="tags.length > 0">
          <a-badge
            v-for="(tag, index) in tags"
            :key="tag.topicId"
            class="c_tag"
          >
            <template #count>
              <close-circle-filled
                style="color: #e75934"
                @click="handleClose(index)"
              />
            </template>
            <a-button
              type="primary"
              style="border-color: #e8e8e8; color: #333; border-radius: 2px"
              ghost
              >{{ tag.topicName }}</a-button
            >
          </a-badge>
        </span>
        <div class="search">
          <a-input-search
            type="text"
            size="big"
            v-model:value.trim()="tagName"
            placeholder="输入主题词"
            @change="changeTagName"
            v-show="tags.length <= 4"
          />
          <div class="list" v-show="tagName.length > 1">

            <div
              class="item"
              v-for="item in selectList"
              :key="item.topicId"
              @click.stop="selectTag(item)"
            >
              {{ item.topicName }}
            </div>
          </div>
        </div>
        <span v-show="tags.length <= 4"> ({{ tags.length }}/5) </span>
        <div
          class="tips"
          style="display: inline-block; color: #f00; margin-left: 10px"
          v-show="
            tagName.length != 0 && (tagName.length < 2 || tagName.length > 30)
          "
        >
          请输入2~30个字符
        </div>
        <div class="desc">
          <a-textarea
            show-count
            :maxlength="200"
            :auto-size="{ minRows: 10, maxRows: 10 }"
            placeholder="请输入论文集简介"
            v-model:value="content"
          ></a-textarea>
        </div>
      </div>
      <div class="btns" style="text-align: center;margin-top:66px">
        <a-button type="primary" @click="save">发布</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  nextTick,
  onBeforeMount,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "vue";
import { QuestionCircleOutlined, CloseCircleFilled } from "@ant-design/icons-vue";
import Http from "../../until/http";
import { messageTips,getCookie } from "../../until/tools";
import { debounce } from "lodash-es";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  components: { QuestionCircleOutlined, CloseCircleFilled},
  setup() {
    let inputRef = ref(null);

    const state = reactive({
      inputVisible: false,
      title: "",
      tags: [],
      tagName: "",
      selectList: [],
      content: "",
    });

    const route = useRoute();
    const router  = useRouter();

    const fatch = debounce((value) => {
      Http.getTopics({ topicName: value }).then((res) => {
        if (res.topicList) {
          Object.assign(state, {
            selectList: res.topicList,
          });
        }
      });
    }, 1000);

    const handleClose = (index) => {
      state.tags.splice(index, 1);
    };
    const showInput = () => {
      Object.assign(state, {
        inputVisible: true,
      });
      nextTick(() => {
        inputRef.value.focus();
      });
    };

    // const selectTag = (item) => {
    //   let index = -1;
    //   state.tags.some((value, key) => {
    //     if (value.topicId === item.topicId) {
    //       index = key;
    //       return true;
    //     }
    //   });
    //   if (index === -1) {
    //     state.tags.push(item);
    //       Object.assign(state,{
    //         selectList:"",
    //       tagName:'',
    //       inputVisible:false
    //     })
    //   }
    // };
     const selectTag = (item) => {
      let index = -1;
      state.tags.some((value, key) => {
        if (value.topicId === item.topicId) {
          index = key;
          return true;
        }
      });
      // if (index === -1) {
      //   state.tags.push(item);
      //   Object.assign(state, {
      //     tagName: "",
      //     inputVisible: false,
      //   });
      // }
      if (index === -1) {
        let arr = [...state.tags, item];
        Object.assign(state, { tags: arr });
      }
      setTimeout(() => {
        Object.assign(state, {
          tagName: "",
        });
      }, 30);
      clickEvent();
    };

    const changeTagName = () => {
      fatch(state.tagName);
    };

    function clickEvent() {
      Object.assign(state, {
        inputVisible: false,
        // tagName: "",
        selectList: [],
      });
    }

    const save = () => {
      if (state.title.trim() === "") {
        messageTips("请输入标题", 2);
        return false;
      }
      if (state.tags.length === 0) {
        messageTips("请添加主题词", 2);
        return false;
      }
      let tags = state.tags.map((item) => {
        return item.topicId;
      });
      Http.createCollection({
        aggName: state.title,
        summary: state.content,
        topicId: tags.join(","),
      }).then((res) => {
        if (res) {
          if (res.success) {
            Object.assign(state, {
              inputVisible: false,
              title: "",
              tags: [],
              tagName: "",
              selectList: [],
              content: "",
            });
            if(route.query.needback) {
              Http.addEssayToMyCollections({
                aggId: res.aggId,
                id: route.query.articleId,
              }).then(()=>{
                messageTips('添加成功', 3);
                router.go(-1)
              });
            } else {              
              messageTips(res.message, 3);
            }
          } else {
            messageTips(res.message, 1);
          }
        }
      });
    }
const showAddNewTopic = () => {
      let isset = false;
      state.selectList.some((item) => {
        if (item.topicName === state.tagName) {
          isset = true;
          return true;
        }
      });
      return !isset;
    };
    onMounted(() => {
      let sid = getCookie('z_sid');
      if(!sid) {
        router.push('/login');
        return false;
      }
      // document.addEventListener("click", clickEvent);
    });

    onBeforeMount(() => {
      // document.removeEventListener("click", clickEvent);
    });

    return {
      ...toRefs(state),
      handleClose,
      showInput,
      inputRef,
      changeTagName,
      selectTag,
      save,
      showAddNewTopic
    };
  },
});
</script>

<style lang="scss">
@import "../../scss/create_collection.scss";
</style>